import { LegendItem } from '@modules/charts/components/LegendItem';
import { LegendItemVariants, LegendLabel } from '@modules/charts/types';
import { useGetColor } from '@modules/common/hooks';
import { GetChartLabelOptions } from '@modules/common/types';
import { Grid } from '@mui/material';
import { FieldNames } from 'v2/core/entities/fields';

interface VerticalLegendProps {
  labels: LegendLabel[];
  totalRecords?: number;
  fieldName?: FieldNames;
  getColor?: (index: number, label: LegendLabel) => string;
  variant?: LegendItemVariants;
  getLabelOptions?: GetChartLabelOptions;
  onMouseEnter?: (event: React.MouseEvent, index: number) => void;
  onMouseLeave?: (event: React.MouseEvent) => void;
}

export function VerticalLegend({
  labels = [],
  totalRecords,
  fieldName,
  getColor,
  variant = 'large',
  getLabelOptions,
  onMouseEnter,
  onMouseLeave,
}: VerticalLegendProps) {
  const getChartColor = useGetColor({ fieldName });

  return (
    <Grid
      container
      spacing={1}
      direction="column"
      justifyContent="center"
      flexWrap="nowrap"
      sx={{ maxHeight: '100%', overflowY: 'auto', overflowX: 'hidden' }}
    >
      {labels.map((label, index: number) => {
        const color = getColor
          ? getColor(index, label)
          : getChartColor(index, label.name);
        return (
          <Grid item key={label.id}>
            <LegendItem
              id={label.id}
              label={label.name}
              itemValue={label.value}
              index={index}
              totalRecords={totalRecords}
              layout="vertical"
              color={color}
              variant={variant}
              getLabelOptions={getLabelOptions}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}
